import type { MessageActionResult } from '../state/chatTypes';
import type { StreamActionResult } from './actionResult';

/**
 * Builds the result an answer shows from an `actionResult` frame.
 * @param id - Local id for the result.
 * @param result - The action result frame's arm.
 * @returns The result to store on the answer.
 */
export const toMessageActionResult = (
  id: string,
  { action, outcome, message, mapUrl, detailsUrl }: StreamActionResult
): MessageActionResult => ({
  id,
  action,
  outcome,
  message,
  ...(mapUrl !== undefined ? { mapUrl } : {}),
  ...(detailsUrl !== undefined ? { detailsUrl } : {}),
});
